import './VehicleCard.css';

const VehicleCard = ({ vehicle, onClick }) => {

  if (!vehicle) {
    return <div className="vehicle-card-container">Nessun veicolo disponibile</div>;
  }

  return (
    <div className="vehicle-card-container" onClick={onClick}>
      <h3>{vehicle.name || 'Nome veicolo non disponibile'}</h3>    
      {vehicle.image ? (
        <img src={vehicle.image} alt={vehicle.name}></img>
      ) : (
        <p>Immagine non disponibile</p>
      )}
      <p className="price">Prezzo: €{vehicle.price !== undefined ? vehicle.price : 'Prezzo veicolo non disponibile'}</p>
      <p>
        {vehicle.matriculation !== undefined ? vehicle.matriculation : 'Data di immatricolazione veicolo non disponibile'} |&nbsp; 
        {vehicle.fuel !== undefined ? vehicle.fuel : 'Carburante veicolo non disponibile'} |&nbsp;
        {vehicle.km !== undefined ? vehicle.km : 'Chilometraggio veicolo non disponibile'} km.
      </p>
    </div>
  );
  
}

export default VehicleCard;